(function($) {
  
    $(document).ready(function() {
        
    });
  
})(jQuery);

function initOpenUserMenu(){
    var $ = jQuery;
    $('.js-open-user-menu').attr('js-lock',0);
    $('.js-open-user-menu').on('click',function(){
        var jslock = $(this).attr('js-lock');
        if(jslock == 0){
            //console.log('y')
            $(this).attr('js-lock',1);
            $('body').toggleClass('mobile-menu-loggedin');
            window.setTimeout(function(){
                $('.js-open-user-menu').attr('js-lock',0);
            },100);
        }
    })
}